import API from './API';

const SubscriptionPlanAPI = {
	get: (type, period) => API.get(`/plans/${type}/${period}`),
	index: params => API.get('/plans', { params }),
	getInfo: () => API.get('/info', { params: { type: 'plans' } }),
	updateOrCreate: (data, id) => id ? API.put(`/plans/${id}`, data) : API.post('/plans', data),
};
export default SubscriptionPlanAPI;
